import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('webEDIShipToStore')
@observer
class WebEDIShipTo extends Component {
  render() {
    const { webEDIShipToStore } = this.props
    const { isFetching } = webEDIShipToStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default WebEDIShipTo;
